import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { pdfjs } from 'react-pdf';
import { StyledDocument, StyledPage, PageContainer, LoadingContainer } from './styles';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

function TermsAndConditionsViewer({ documents, currentPage }) {
  const [numPages, setNumPages] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [pageWidth, setPageWidth] = useState(900);
  const documentRef = useRef(null);

  const onDocumentLoadSuccess = ({ numPages: loadedNumPages }) => {
    setNumPages(loadedNumPages);
    if (documentRef.current) {
      documentRef.current.scrollTop = 0;
    }
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);

    const dialogElement = document.querySelector('[role="dialog"]');
    if (dialogElement) {
      dialogElement.style.width = 'min(100rem, calc(100vw - 3.2rem))';
      dialogElement.style.minWidth = '0';
      dialogElement.style.maxWidth = 'calc(100vw - 3.2rem)';
    }
  }, [currentPage]);

  useEffect(() => {
    const updatePageWidth = () => {
      const availableWidth = documentRef.current?.clientWidth || window.innerWidth;
      setPageWidth(Math.max(280, Math.min(900, availableWidth - 24)));
    };

    updatePageWidth();

    const resizeObserver =
      typeof ResizeObserver !== 'undefined' ? new ResizeObserver(updatePageWidth) : null;
    if (resizeObserver && documentRef.current) {
      resizeObserver.observe(documentRef.current);
    }

    window.addEventListener('resize', updatePageWidth);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener('resize', updatePageWidth);
    };
  }, []);

  const renderPages = () => {
    if (isLoading) {
      return (
        <LoadingContainer>
          <p>Loading PDF...</p>
        </LoadingContainer>
      );
    }

    const pages = [];
    if (numPages) {
      for (let i = 1; i <= numPages; i += 1) {
        pages.push(
          <PageContainer key={`page_${i}`}>
            <StyledPage pageNumber={i} width={pageWidth} />
          </PageContainer>,
        );
      }
      return pages;
    }
    return null;
  };

  return (
    <div ref={documentRef} style={{ minHeight: '500px' }}>
      {documents.map((url, index) => (
        <div
          key={`${url}_${currentPage}`}
          style={{ display: index === currentPage ? 'block' : 'none' }}
        >
          <StyledDocument file={url} onLoadSuccess={onDocumentLoadSuccess}>
            {renderPages()}
          </StyledDocument>
        </div>
      ))}
    </div>
  );
}

TermsAndConditionsViewer.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentPage: PropTypes.number.isRequired,
};

export default TermsAndConditionsViewer;
